import React from 'react';
import NgUiSpinner from '../ng-ui-widgets/src/components/Spinner';

const Spinner = (props) => (
  <React.Suspense fallback={<div />}>
    <NgUiSpinner {...props} />
  </React.Suspense>
);
export default Spinner;
